import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class OfficeSelectorCfg {
  public listEndpoint: string;
  public detailEndpoint: string;
  public teaCompanyId: string;
  public uPayrollBranchId: string;
  public fundationCompanyId: string;
}

@Injectable({
  providedIn: 'root'
})
export class OfficeSelectorCfgService extends CfgService<OfficeSelectorCfg> {
  json: any = {
    listEndpoint: "%{CommonsFrontUrl}/employees/structure",
    detailEndpoint: "%{CommonsFrontUrl}/branches",
    teaCompanyId: "01",
    uPayrollBranchId: "3208",
    fundationCompanyId: "FUN"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/officeSelector.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
